import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import './ProcessNodes.css';

/**
 * Cross-Link Node -- canvas card for the `cross_link` execution type.
 *
 * Surfaces the target type (process / graph / router) and the target's
 * display name (or id) so the node is identifiable without opening the
 * properties panel.
 */
function CrossLinkNode({ data, selected }) {
  const inputCount = data.inputs?.length || 0;
  const outputCount = data.outputs?.length || 0;
  const cfg = data.cross_link_config || {};
  const targetType = cfg.target_type || 'process';

  let targetLabel = '(no target)';
  if (targetType === 'process') {
    targetLabel = cfg.target_process_name || cfg.target_process_id || '(pick a process)';
  } else if (targetType === 'graph') {
    targetLabel = cfg.graph_name || cfg.graph_id || '(pick a graph)';
  } else if (targetType === 'router') {
    targetLabel = cfg.router_graph_name || cfg.router_graph_id || '(pick a router)';
  }
  const preview = targetLabel.length > 30 ? `${targetLabel.slice(0, 27)}…` : targetLabel;

  return (
    <div className={`process-node cross-link-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Left} className="node-handle input-handle" />

      <div className="node-header">
        <span className="node-icon">🔗</span>
        <span className="node-type-badge cross-link">CROSS-LINK</span>
      </div>

      <div className="node-body">
        <div className="node-name">{data.name || 'Cross-Link Node'}</div>
        {data.description && (
          <div className="node-description">{data.description}</div>
        )}
        <div className="node-http-summary">
          <span className="http-method http-method-get">{targetType}</span>
          <span className="http-url" title={targetLabel}>{preview}</span>
        </div>
      </div>

      <div className="node-footer">
        <div className="node-meta">
          <span className="meta-item">
            <span className="meta-icon">↓</span>
            {inputCount} input{inputCount !== 1 ? 's' : ''}
          </span>
          <span className="meta-item">
            <span className="meta-icon">↑</span>
            {outputCount} output{outputCount !== 1 ? 's' : ''}
          </span>
        </div>
      </div>

      <Handle type="source" position={Position.Right} className="node-handle output-handle" />
    </div>
  );
}

export default memo(CrossLinkNode);
